import React from 'react';
import { Typography } from '@material-ui/core';

export const CheckInUnavailable: React.FC = () => (
  <Typography variant="h1" align="center" paragraph>
    No rooms are currently available for check-in.
  </Typography>
);
